import angular from 'angular';
import { PayoutPostingModule } from '../../posting/payout-posting.module';

import { PostedPayoutsDashboardContainerComponent } from './posted-payouts-dashboard/posted-payouts-dashboard-container.component';
import { WorkOrderPayoutReportComponent } from './work-order-payout-report/work-order-payout-report.component';
import { RogersReportHistoryComponent } from '../rogershistory/rogers-report-history.component';
import { RogersReportHistoryDetailsModalComponent } from '../rogershistory/rogers-report-history-details-modal.component';

/**
 * A module containing top-level reporting pages that perform data loading
 * and make decisions on which customized report to display depending on
 * the selected division.
 */
export const PayoutReportContainerModule = angular
    .module("apex.mainApp.payout.report.container", [
        PayoutPostingModule
    ])
    .component("apexPostedPayoutsDashboardContainer", PostedPayoutsDashboardContainerComponent)
    .component("apexWorkOrderPayoutReport", WorkOrderPayoutReportComponent)
    .component("apexRogersReportHistory", RogersReportHistoryComponent)
    .component("apexRogersReportHistoryDetailModal", RogersReportHistoryDetailsModalComponent)
    .name;
